import { render, staticRenderFns } from "./CrmSalonSalons.vue?vue&type=template&id=e10f67b6&"
import script from "./CrmSalonSalons.vue?vue&type=script&lang=js&"
export * from "./CrmSalonSalons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports